module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/eb67f5dfdeb1ebfa3f54e5c026de9cd9.gif";